// extracted by mini-css-extract-plugin
module.exports = {"card":"SFpqYeY_2NJcWwK-qW53e"};